import React, {useState} from 'react';
import '../styles/Testimonials.css';

const Testimonials = () => {
    const [testimonialData, setTestimonialData] = useState([
        {
            "testimonial_text": "I’ve had the pleasure of getting to know Ainsley over the past 5 years and watch her develop into a wonderful rider and human. Ainsley is a great student, is always eager to learn, and constantly showing compassion for her horses and the people around her. Ainsley has ridden a multitude of different types of horses and brings out the best in each one. She maintains a positive attitude and always puts the horses first whether it is her best day in the show ring, or a day of learning. She has a beautiful presence on a horse and a lovely, soft feel. Being a collegiate athlete myself, I know Ainsley would make a wonderful addition to any team with her great work ethic, talent, and positive nature.",
            "author": "Kylee Arbuckle",
            "phone_number": "(310) 293-1667",
            "image":"./slideshow2/4.jpg"
        },
        {
            "testimonial_text": "To whom it may concern, <br/> I have known Ainsley for over 10 years. From the first days of teaching her on her pony, she has been an enthusiastic equestrian. With her horses living on her family farm, she has always been hands on in their care and daily activity. From riding in the ring, to taking them on trails in the mountains, to galloping on the beach, she, more than their rider, is their friend. Over the years, Ainsley has participated in the Hunters, Jumpers and Equitation adjusting to different horses, and competing all over the country. She works hard and always has a good attitude. As a trainer, she is the kind of student you love to have. She works hard in her lessons, is organized and attentive at shows, and is a cheerleader for her barn mates. I’m proud of the horse woman she has become and have loved being a part of her riding career.",
            "author": "Heather Roades",
            "phone_number": "(818) 383-3461",
            "image":"./album-pictures/53.jpg"
        },
        {
            "testimonial_text":"A prominent trainer once told me that selection is eighty five percent of training. We hosted a modified nations cup at the Ethel Walker school. In our format teams tied for podium positions would break ties by designating one rider to jump off. When Ainsley's team tied for the gold my job became easy. Ainsley stepped up to the pressure and sealed the gold with a solid clear round. I'm told that Ainsley is often a point rider for the IEA team. Her position and effectiveness are representative of her talent and time in the saddle. She is a winner in the jumper ring, equitation medals and junior hunters. Ainsley is a horseman and a supportive team player.",
            "author": "Ken Whelihan",
            "phone_number": "(860) 408 43551",
            "image":"./slideshow2/4.jpg"
        }
    ]);
    React.useEffect(()=>{
        document.getElementsByTagName('title')[0].innerHTML='Ainsley Davis 2026 - Testimonials';
    },[])
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 800); // Set initial state based on current window width
    React.useEffect(() => {
        // Function to update state based on window width
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 800);
        };

        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="floating-container">
            <h1 className="testimonials-title">Testimonials</h1>
            {
                testimonialData.map((testimonial, index) => {
                    let cond = index%2 == 0
                    console.log(cond);
                    return (
                        <div style={{padding: '0px'}} className="equestrian-container">
                            {cond && <div className="image-container">
                                <img src={testimonial.image} alt="Ainsley Davis"/>
                            </div>}
                            <div style={ (cond)?
                                ( (!isMobile) ? {marginLeft: '20px'} : {}):
                                ((!isMobile)?{marginRight:'20px', textAlign:'right'}:{})
                            } className="testimonial">
                                <p className="testimonial-text" dangerouslySetInnerHTML={{ __html: testimonial.testimonial_text }} >

                                </p>
                                <p className="testimonial-author" style={{userSelect: 'text'}}>
                                    ~ {testimonial.author}
                                    <br/>
                                    {testimonial.phone_number}
                                </p>
                            </div>
                            {!cond && <div className="image-container">
                                <img src={testimonial.image} alt="Ainsley Davis"/>
                            </div>}
                        </div>
                    )
                })
            }


        </div>
    );
};

export default Testimonials;